import { SubjectId } from "@carnegie-learning/common-types";
import { CoursePaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { User } from "@carnegie-learning/data-access-fido";
import { createAction, props } from "@ngrx/store";
import {
    Course,
    CourseMetrics,
    Student,
    WelcomeContentInterface,
} from "cli-types";

// ------ Load teacher-classes ------
export const loadCourses = createAction(
    "[Courses] Load Courses",
    props<{
        payload: CoursePaginationParameters;
    }>()
);
export const loadCoursesFail = createAction(
    "[Courses] Load Courses Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCoursesSuccess = createAction(
    "[Courses] Load Courses Success",
    props<{
        payload: any /*CoursePagination*/;
    }>()
);

// ------ Set Pagination Params -------
export const setCoursesPaginationParams = createAction(
    "[Courses] Set Pagination Params",
    props<{
        payload: any;
    }>()
);

// Load Teacher teacher-class dropdown
export const loadCoursesDropdown = createAction(
    "[Courses] Load Courses Dropdown"
);
export const loadCoursesDropdownFail = createAction(
    "[Courses] Load Courses Dropdown Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCoursesDropdownSuccess = createAction(
    "[Courses] Load Courses Dropdown Success",
    props<{
        payload: any;
    }>()
);

// Set courses loading no effects
export const setCoursesDropdownLoading = createAction(
    "[Courses] Set Courses Dropdown Loading"
);

export const setCoursesDropdownLoaded = createAction(
    "[Courses] Set Courses Dropdown Loaded"
);

// ------ Load Teacher Course Dropdown Fido Student data ------
export const loadCoursesFidoStudentsDropdown = createAction(
    "[Courses] Load Courses Fido Students Dropdown",
    props<{
        studentUUIDs: string[];
    }>()
);
export const loadCoursesFidoStudentsDropdownFail = createAction(
    "[Courses] Load Courses Fido Students Dropdown Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCoursesFidoStudentsDropdownSuccess = createAction(
    "[Courses] Load Courses Fido Students Dropdown Success",
    props<{
        courses: Course[];
        fidoData: User[];
    }>()
);

// ------ Load single teacher-class ------
export const loadCourse = createAction(
    "[Courses] Load Course",
    props<{
        courseID: number;
    }>()
);
export const loadCourseFail = createAction(
    "[Courses] Load Course Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCourseSuccess = createAction(
    "[Courses] Load Course Success",
    props<{
        payload: any;
    }>()
);

// ------ Create teacher-class ------
export const createCourse = createAction(
    "[Courses] Create Course",
    props<{
        payload: Course;
    }>()
);
export const createCourseFail = createAction(
    "[Courses] Create Course Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const createCourseSuccess = createAction(
    "[Courses] Create Course Success",
    props<{
        payload: Course;
    }>()
);

// ------ Update teacher-class ------
export const updateCourse = createAction(
    "[Courses] Update Course",
    props<{
        payload: Course;
    }>()
);
export const updateCourseFail = createAction(
    "[Courses] Update Course Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const updateCourseSuccess = createAction(
    "[Courses] Update Course Success",
    props<{
        payload: Course;
    }>()
);

export const setCourseGrid = createAction(
    "[Courses] Set Course Grid",
    props<{
        courseID: number;
        gridID: number;
    }>()
);

export const regenCourseGrid = createAction(
    "[Courses] Regen Course Grid",
    props<{
        courseID: number;
    }>()
);

// ------ Update Roster teacher-classes Bulk------
export const updateRosterCoursesBulk = createAction(
    "[Courses] Update Roster Courses Bulk",
    props<{
        payload: Course[];
    }>()
);
export const updateRosterCoursesBulkFail = createAction(
    "[Courses] Update Roster Courses Bulk Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const updateRosterCoursesBulkSuccess = createAction(
    "[Courses] Update Roster Courses Bulk Success",
    props<{
        payload: Course[];
    }>()
);

// ------ Archive teacher-class ------
export const archiveCourse = createAction(
    "[Courses] Archive Course",
    props<{
        payload: Course;
    }>()
);
export const archiveCourseFail = createAction(
    "[Courses] Archive Course Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const archiveCourseSuccess = createAction(
    "[Courses] Archive Course Success",
    props<{
        payload: Course;
    }>()
);

// ------ Reactivate teacher-class ------
export const reactivateCourse = createAction(
    "[Courses] Reactivate Course",
    props<{
        payload: Course;
    }>()
);
export const reactivateCourseFail = createAction(
    "[Courses] Reactivate Course Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const reactivateCourseSuccess = createAction(
    "[Courses] Reactivate Course Success",
    props<{
        payload: Course;
    }>()
);

// ------ Remove teacher-class ------
export const removeCourse = createAction(
    "[Courses] Remove Course",
    props<{
        payload: Course;
    }>()
);
export const removeCourseFail = createAction(
    "[Courses] Remove Course Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const removeCourseSuccess = createAction(
    "[Courses] Remove Course Success",
    props<{
        payload: Course;
    }>()
);

export const setSelectedCourse = createAction(
    "[Courses] Set Selected Course",
    props<{
        payload: Course | null;
    }>()
);
export const updateSelectedCourseSuccess = createAction(
    "[Courses] Updated Selected Course Success",
    props<{
        courseID: number | null;
    }>()
);
export const updateSelectedCourseFail = createAction(
    "[Courses] Updated Selected Course Fail"
);

export const selectedCourseNoAction = createAction(
    "[Courses] Selected Course No Action"
);

export const loadSelectedCourse = createAction(
    "[Courses] Load Selected Course",
    props<{
        courseID: number;
    }>()
);
export const loadSelectedCourseFail = createAction(
    "[Courses] Load Selected Course Fail"
);
export const loadSelectedCourseSuccess = createAction(
    "[Courses] Load Selected Course Success",
    props<{
        course: Course;
    }>()
);

export const clearCourses = createAction("[Courses] Clear Courses");

// ------ Load teacher-classes background ------
export const loadCoursesBackground = createAction(
    "[Courses] Load Courses Background",
    props<{
        subjectId: SubjectId;
        timeOfDay: string;
    }>()
);
export const loadCoursesBackgroundFail = createAction(
    "[Courses] Load Courses Background Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCoursesBackgroundSuccess = createAction(
    "[Courses] Load Courses Background Success",
    props<{
        payload: WelcomeContentInterface;
    }>()
);

// Commenting out for PAS-11616
// ------ Load single teacher-class background image (banner) ------
// export const loadBackgroundImage = createAction(
//     "[Courses] Load Background Image",
//     props<{
//         subjectId: SubjectId;
//         timeOfDay: string;
//     }>()
// );
// export const loadBackgroundImageFail = createAction(
//     "[Courses] Load Background Image Fail",
//     props<{
//         payload: any;
//     }>()
// ); // if failure, we need constructor to send a message as the payload property back from the server
// export const loadBackgroundImageSuccess = createAction(
//     "[Courses] Load Background Image Success",
//     props<{
//         payload: WelcomeContentInterface;
//     }>()
// );

// ------ Load studentMetrics ------
export const loadCourseMetrics = createAction(
    "[Courses] Load Metrics",
    props<{
        courseID: number;
    }>()
);
export const loadCourseMetricsFail = createAction(
    "[Courses] Load Metrics Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCourseMetricsSuccess = createAction(
    "[Courses] Load Metrics Success",
    props<{
        courseID: number;
        courseMetrics: CourseMetrics;
    }>()
);

// ------ Updates Students State inside the Course Branch. No api call, just state syncing ------
// We don't need Remove because the Assign form only shows active students
// and we can only remove from the teacher-class Archived tab
export const addCourseStudent = createAction(
    "[Courses] Add Course Student",
    props<{
        payload: Student;
        courseID: number;
    }>()
);
export const updateCourseStudent = createAction(
    "[Courses] Update Course Student",
    props<{
        payload: Student;
        courseID: number;
    }>()
);
export const archiveCourseStudent = createAction(
    "[Courses] Archive Course Student",
    props<{
        payload: Student;
        courseID: number;
    }>()
);
export const reactivateCourseStudent = createAction(
    "[Courses] Reactivate Course Student",
    props<{
        payload: Student;
        courseID: number;
    }>()
);

// ------ Set Filter Box State -------
export const setCourseFilterBoxOpened = createAction(
    "[Courses] Filter Box Opened",
    props<{
        payload: any;
    }>()
);

// ----- Increase Student Count
export const increaseStudentCount = createAction(
    "[Courses] Increase Student Count",
    props<{
        courseID: number;
    }>()
);

// ----- Decrease Student Count
export const decreaseStudentCount = createAction(
    "[Courses] Decrease Student Count",
    props<{
        courseID: number;
    }>()
);
